import { CanMatchFn, Routes } from '@angular/router';
import { ChangePasswordComponent as EmployerChangePasswordComponent } from './employer/account/change-password/change-password.component';
import { LoginComponent as EmployerLoginComponent } from './employer/account/login/login.component';
import { PasswordComponent as EmployerPasswordComponent } from './employer/account/password/password.component';
import { SignupComponent as EmployerSignupComponent } from './employer/account/signup/signup.component';
import { AgreementComponent as SharedAgreementComponent } from './shared/agreement/agreement.component';

import { ChangePasswordComponent as EmployeeChangePasswordComponent } from './employee/account/change-password/change-password.component';
import { LoginComponent as EmployeeLoginComponent } from './employee/account/login/login.component';
import { PasswordComponent as EmployeePasswordComponent } from './employee/account/password/password.component';
import { SignupComponent as EmployeeSignupComponent } from './employee/account/signup/signup.component';
import { UsernameComponent as EmployeeUsernameComponent } from './employee/account/username/username.component';

import { environment } from '../environments/environment';
import { SalesForceLoginComponent } from './customidp/sales-force/login/login.component';
import { SalesForceVerifyComponent } from './customidp/sales-force/verify/verify.component';
import { UserLoginComponent } from './customidp/user/login/login.component';
import { UserVerifyComponent } from './customidp/user/verify/verify.component';
import { LandingComponent } from './landing/landing.component';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { PrivacyPolicyComponent } from './shared/privacy-policy/privacy-policy.component';
import { TermsConditionsEmployeeComponent } from './shared/terms-conditions-employee/terms-conditions-employee.component';
import { VerifyComponent } from './shared/verify/verify.component';

const intranetOnlyGuard: CanMatchFn = () => {
  const disableGuards = environment.disableRouteGuards as boolean | string;
  if (disableGuards === true || disableGuards === 'true') return true;
  const value = environment.isIntranet as boolean | string;
  return value === true || value === 'true';
};
const nonIntranetOnlyGuard: CanMatchFn = () => {
  const disableGuards = environment.disableRouteGuards as boolean | string;
  if (disableGuards === true || disableGuards === 'true') return true;
  const value = environment.isIntranet as boolean | string;
  return value === false || value === 'false' || !value;
};

export const routes: Routes = [
  { path: '', component: LandingComponent, pathMatch: 'full', title: 'Home' },

  { path: 'employer/account/login', component: EmployerLoginComponent, canMatch: [nonIntranetOnlyGuard], title: 'Employer | Login' },
  {
    path: 'employer/account/signup',
    component: EmployerSignupComponent,
    canMatch: [nonIntranetOnlyGuard],
    title: 'Employer | Sign Up'
  },
  {
    path: 'employer/account/agreement',
    component: SharedAgreementComponent,
    data: { userType: 'employer' },
    canMatch: [nonIntranetOnlyGuard],
    title: 'Employer | Agreement'
  },
  {
    path: 'employer/account/password',
    component: EmployerPasswordComponent,
    canMatch: [nonIntranetOnlyGuard],
    title: 'Employer | Password Reset'
  },
  {
    path: 'employer/account/change-password',
    component: EmployerChangePasswordComponent,
    canMatch: [nonIntranetOnlyGuard],
    title: 'Employer | Change Password'
  },
  {
    path: 'employer/account/verify',
    component: VerifyComponent,
    canMatch: [nonIntranetOnlyGuard],
    title: 'Employer | Verification'
  },

  { path: 'employee/account/login', component: EmployeeLoginComponent, canMatch: [nonIntranetOnlyGuard], title: 'Employee | Login' },
  {
    path: 'employee/account/signup',
    component: EmployeeSignupComponent,
    canMatch: [nonIntranetOnlyGuard],
    title: 'Employee | Sign Up'
  },
  {
    path: 'employee/account/password',
    component: EmployeePasswordComponent,
    canMatch: [nonIntranetOnlyGuard],
    title: 'Employee | Password Reset'
  },
  {
    path: 'employee/account/username',
    component: EmployeeUsernameComponent,
    canMatch: [nonIntranetOnlyGuard],
    title: 'Employee | Username Recovery'
  },
  {
    path: 'employee/account/agreement',
    component: SharedAgreementComponent,
    data: { userType: 'employee' },
    canMatch: [nonIntranetOnlyGuard],
    title: 'Employee | Agreement'
  },
  {
    path: 'employee/account/change-password',
    component: EmployeeChangePasswordComponent,
    canMatch: [nonIntranetOnlyGuard],
    title: 'Employee | Change Password'
  },
  {
    path: 'employee/account/verify',
    component: VerifyComponent,
    canMatch: [nonIntranetOnlyGuard],
    title: 'Employee | Verification'
  },

  { path: 'terms-and-conditions-employee-id', component: TermsConditionsEmployeeComponent, canMatch: [nonIntranetOnlyGuard], title: 'Terms and Conditions' },
  { path: 'terms-and-conditions-employer-id', component: TermsConditionsEmployeeComponent, canMatch: [nonIntranetOnlyGuard], title: 'Terms and Conditions' },

  { path: 'privacy-policy', component: PrivacyPolicyComponent, canMatch: [nonIntranetOnlyGuard], title: 'Privacy Policy' },

  { path: 'customidp/salesforce/login', component: SalesForceLoginComponent, canMatch: [nonIntranetOnlyGuard], title: 'Salesforce | Login' },
  { path: 'customidp/salesforce/verify', component: SalesForceVerifyComponent, canMatch: [nonIntranetOnlyGuard], title: 'Salesforce | Verification' },
  { path: 'customidp/user/login', component: UserLoginComponent, canMatch: [intranetOnlyGuard], title: 'User | Login' },
  { path: 'customidp/user/verify', component: UserVerifyComponent, canMatch: [intranetOnlyGuard], title: 'User | Verification' },

  { path: '**', component: NotFoundComponent, title: 'Page Not Found' },
];
